import { getQueryMethod, resources, entities, methods } from '../utils';
const { meloAPI } = resources;
const { businesses } = entities;
const { POST, PATCH } = methods;

const query = getQueryMethod(meloAPI, businesses);

const endpoints = {
  createBusiness: async businessData => {
    return await query('', POST, businessData);
  },
  getBusiness: async businessId => {
    return await query(businessId);
  },
  updateBusiness: async (businessId, body) => {
    return await query(businessId, PATCH, body);
  },
  getDIANConnectionToken: async businessId => {
    return await query(`integrations/dian/get-token/${businessId}`);
  },
  updateDIANConnection: async (businessId, invoicesExtractStartDate) => {
    return await query('integrations/dian/update-connection', PATCH, { businessId, invoicesExtractStartDate });
  },
  deleteDIANConnection: async businessId => {
    return await query('integrations/dian/delete-connection', PATCH, { businessId });
  },
  getBANKConnectAccountLink: async data => {
    return await query('integrations/bank/get-link', POST, data);
  },
  deleteBANKAccounts: async (businessId, druoAccountsIds) => {
    return await query('integrations/bank/delete-accounts', PATCH, { businessId, druoAccountsIds });
  },
  setDefaultBankAccount: async (businessId, druoAccountId) => {
    return await query('integrations/bank/set-default', PATCH, { businessId, druoAccountId });
  },
  getDruoConnections: async businessId => {
    return await query(`integrations/bank/get-connections/${businessId}`);
  },
  getDIANConnection: async businessId => {
    return await query(`integrations/dian/get-connections/${businessId}`);
  },
  deletePSEAccount: async (businessId, pseCustomerIndex) => {
    return await query('integrations/pse/delete-connections', PATCH, { businessId, pseCustomerIndex });
  },
  setDefaultBankAccount: async (businessId, druoAccountId) => {
    return await query('integrations/bank/set-default', PATCH, { businessId, druoAccountId });
  }
};

export default endpoints;
